import * as t from 'react';
import { forwardRef, memo } from 'react';

var m=({title:r,titleId:e,...a},o)=>t.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:o,"aria-labelledby":e,...a},r?t.createElement("title",{id:e},r):null,t.createElement("path",{d:"M8 1a7 7 0 1 0 5 2.05A7 7 0 0 0 8 1m0 13a6 6 0 1 1 4.24-1.76A6 6 0 0 1 8 14","data-name":"Path 14"}),t.createElement("path",{d:"M5 7.5v1h6v-1Z","data-name":"Path 15"})),n=forwardRef(m),f=memo(n),S=f;

export { S as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-XFNIATUH.mjs.map